import React, { PropTypes } from 'react';
import { NitroHeading, NitroButton, NitroButtonGroup, NitroParagraph, NitroPanel } from 'nitro-components';

const QuoteActions = ({ exportAction, isExporting, submitAction, isSubmitting}) => (
  <NitroPanel>

    <NitroHeading label="Next steps" size="2" align="center" />
    <NitroButtonGroup layout="vertical">

      <NitroButton
        variant="secondary"
        label="Export quote"
        size="small"
        width="block"
        action={exportAction}
        loading={isExporting}
        disabled={isExporting}
      />

      <NitroButton
        variant="primary"
        label="Submit order"
        size="small"
        width="block"
        action={submitAction}
        loading={isSubmitting}
        disabled={isSubmitting}
      />

    </NitroButtonGroup>
  </NitroPanel>
);

QuoteActions.propTypes = {
  isExporting: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  exportAction: PropTypes.func,
  submitAction: PropTypes.func,
  steps: PropTypes.string
};

export default QuoteActions;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/components/QuoteActions.js